import React from 'react';
import {
  View,
  Text,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { useAppSelector } from '@/store';
import { PaymentDetailsSummary } from './shared';

interface TransactionReceivedContentProps {
  paymentAmount: number;
  fee: number;
  totalCharged: number;
  paymentMethodLabel: string;
  residentName?: string;
}

/**
 * Transaction Received Content - Shows success message and payment details
 */
export const TransactionReceivedContent: React.FC<TransactionReceivedContentProps> = ({
  paymentAmount,
  fee,
  totalCharged,
  paymentMethodLabel,
  residentName,
}) => {
  const authUser = useAppSelector((s) => (s as any).auth?.user);
  const userEmail = authUser?.email || 'your email';

  return (
    <View style={styles.container}>
      {/* Thank You */}
      <Text style={styles.thankYouTitle}>Thank you!</Text>

      {/* Confirmation Message */}
      <Text style={styles.confirmationText}>
        Your transaction has been received. A confirmation has been sent to {userEmail}.
      </Text>

      {/* Payment Details */}
      <PaymentDetailsSummary
        paymentAmount={paymentAmount}
        fee={fee}
        totalAmount={totalCharged}
        paymentMethodLabel={paymentMethodLabel}
        residentName={residentName}
        containerStyle={styles.detailsContainer}
      />

      {/* Processing Note */}
      <Text style={styles.processingNote}>
        Payments can take up to 5 business days to process completely. Please be sure to keep sufficient funds in your account.
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    paddingVertical: 24,
  },
  thankYouTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 27,
    marginBottom: 16,
  },
  confirmationText: {
    fontSize: 16,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 24,
    marginBottom: 24,
  },
  detailsContainer: {
    marginBottom: 24,
  },
  processingNote: {
    fontSize: 12,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textMuted,
    lineHeight: 18,
  },
});

export default TransactionReceivedContent;
